export const GET_ALL_MAIN_CATEGORIES = "GET_ALL_MAIN_CATEGORIES"
export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES"
export const GET_ALL_SUB_CATEGORIES = "GET_ALL_SUB_CATEGORIES"
